module.exports = __webpack_public_path__ + "static/img/245_TO8_2195_og.b0d962d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/245_TO8_2195_og.jpg
// module id = wX0v
// module chunks = 0